import type { Tables } from "@/integrations/supabase/types";

export type Team = Tables<"team">;

export interface Profile {
  id: string;
  email?: string;
  full_name?: string;
  avatar_url?: string;
  role?: string;
  originalRole?: string;
  stripe_id?: string;
  billing_currency?: 'USD' | 'NZD' | 'AUD' | 'GBP' | 'EUR' | null;
  socials?: number;
  team_id?: number | null;
  timezone?: string;
  phone_number?: string | null;
  phone_country_code?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state_province?: string | null;
  postal_code?: string | null;
  country?: string | null;
  date_of_birth?: string | null;
  preferred_language?: string | null;
  company_name?: string | null;
  job_title?: string | null;
  created_at?: string;
  updated_at?: string;
  team?: Team | null;
}

export interface UserProfile {
  profile_id: string;
  full_name?: string;
  email?: string;
  role?: string;
  avatar_url?: string;
  team_id?: number;
  isImpersonating?: boolean;
  originalUserId?: string;
}

export interface ImpersonationState {
  adminUserId: string;
  impersonatedUserId: string;
  impersonatedAt: number;
}

export enum Roles {
  Admin = "internal_admin",
  Business = "standard_user",
  Consumer = "consumer",
}

export interface UserData {
  profile: Profile | null;
  team: Team | null;
}

export interface TeamMember {
  id: string;
  full_name: string | null;
  email: string | null;
  avatar_url: string | null;
  role: "Owner" | "Member" | "Invited";
}

export interface TeamData extends Team {
  members: TeamMember[];
}

export interface SubscriptionInfo {
  id: number;
  stripe_id: string | null;
  status: string | null;
  price_id: string | null;
  quantity: number | null;
  extra_quantity?: number;
  trial_ends_at: string | null;
  ends_at: string | null;
  created_at: string;
}

export interface CallPurchase {
  id: number;
  user_id: string;
  stripe_id: string | null;
  status: string | null;
  quantity: number | null;
  created_at: string;
}

export interface PhoneSubscription {
  id: number;
  user_id: string;
  phone_number: string | null;
  stripe_id: string | null;
  status: string | null;
  created_at: string;
}

/** A number Help Genie bought for a paying, non-admin account that has no phone subscription for it. */
export interface UnbilledPhoneNumber {
  id: number;
  phone_number_id: string;
  phone_number: string;
  friendly_name: string | null;
  date_created: string;
  agent_id: string;
  agent_name: string | null;
}

export interface ProfileWithSubscription extends Profile {
  subscription?: SubscriptionInfo | null;
  subscriptions?: SubscriptionInfo[];
  call_purchases?: CallPurchase[];
  phone_subscriptions?: PhoneSubscription[];
  unbilled_phone_numbers?: UnbilledPhoneNumber[];
  genie_counts?: { active: number; eligible: number };
}
